<template>
  <div>
    <h3 class="text-left text-font-24">ยืนยันข้อมูล</h3>
    <div v-if="form" class="pd-b-3 flex-display js-center">
      <div class="box-image">
        <avatar
          :rounded="false"
          :username="form.step1.nameTh"
          :src="getUrlImage(form.step1.image)"
          :size="120"
        >
        </avatar>
      </div>
    </div>

    <div v-if="form" class="pd-x-1 text-left set-form-regis">
      <div class="flex-display js-between ai-center border-b mg-b-4">
        <h4 class="mg-y-4 text-font-18">ข้อมูลส่วนบุคคล</h4>
        <a @click="backPage(1)" class="text-font-12 color-primary"
          ><i class="fas fa-pen"></i> แก้ไขข้อมูล</a
        >
      </div>
      <ProfilePersonalInfoView
        :prefix="form.step1.prefix"
        :nameTh="form.step1.nameTh"
        :lastNameTh="form.step1.lastNameTh"
        :nameEn="form.step1.nameEn"
        :lastNameEn="form.step1.lastNameEn"
        :phoneNumber="form.step1.phoneNumberObj.formatNational"
        :idCard="form.step1.idCard"
        :birthDay="form.step1.birthDay"
        :position="form.step1.position"
        :address="form.step1.address"
        :subDistrict="form.step1.subDistrict"
        :district="form.step1.district"
        :province="form.step1.province"
        :postcode="form.step1.postcode"
      />

      <div class="flex-display js-between ai-center border-b mg-b-4 pd-t-4">
        <h4 class="mg-y-4 text-font-18">ข้อมูลหน่วยงาน</h4>
        <a @click="backPage(2)" class="text-font-12 color-primary"
          ><i class="fas fa-pen"></i> แก้ไขข้อมูล</a
        >
      </div>
      <ProfileCompanyView
        :agency="form.step2.agency"
        :agencyType="form.step2.agencyType"
        :address="form.step2.address"
        :subDistrict="form.step2.subDistrict"
        :district="form.step2.district"
        :province="form.step2.province"
        :postcode="form.step2.postcode"
        :etc="form.step2.etc"
      />
      <div :span="24" class="pd-y-3">
        <el-button @click="signup" type="primary" class="width-100" round
          >ลงทะเบียนเรียนออนไลน์</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from "vue-avatar";
import ProfilePersonalInfoView from "@/components/profile/ProfilePersonalInfoView";
import ProfileCompanyView from "@/components/profile/ProfileCompanyView";

export default {
  components: {
    Avatar,
    ProfilePersonalInfoView,
    ProfileCompanyView,
  },
  props: {
    form: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  methods: {
    signup() {
      this.$emit("signup");
    },
    backPage(page) {
      this.$emit("setPage", page);
    },
    getUrlImage(image) {
      if (image != null) {
        return URL.createObjectURL(image.raw);
      } else {
        return "";
      }
    },
  },
};
</script>

<style scoped></style>
